module.exports = __webpack_public_path__ + "img/American Samoa.093b6bc3.svg";